<template>
    <div>
        <swb-query-sort-area class="mt10 mb10" name="query-sort-block" ref="query_model_ctrl" :confKey="confKey" :queryOnLoad="true" :configAuto="true" :queryKey="queryKey"
                             :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        <div name="tab-btn" class="simple-row clearfix" v-if="totalCountX > 10000">
            <div class="left">
            </div>
            <div class="right">
                <span class="font-red mr5" v-if="hintMsg != null && hintMsg != ''">提示：{{hintMsg}}</span>
            </div>
        </div>
        <swb-result-table name="result_table" :confKey="confKey" :configAuto="true" ref="result_table" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect"
                          :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes} from '../../app.vues'
    import {loadRetailerDevcGroupList} from '../retailer/asset-comn';
    import {getDefaultPageSizes} from '../../app.conf';

    import servcDelivApi from '../../api/servcDeliv'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-servc-work-voucher-list-for-select',
        desc: '工单选择',
        props: {
            checkedIds: {// 多选的时候传入
                type: Array,
                default: []
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                confKey: "swb-servc-work-voucher-list-for-select",
                theTableHeight: 550,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 150,//操作列宽度（默认：100）
                //
                btnColFixed: false, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                totalCountX: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                selectIds: [],
                workServcTypeMap: getEnumMap('workServcType', 'value2text'),
                hintMsg: null,
            }
        },
        created: function () {
            if (this.checkBox) {
                this.multiSelect = true;
                this.multiPageSelect = true;
            } else {
                this.multiSelect = false;
                this.multiPageSelect = false;
                this.rowNoShow = true;
            }
            this.selectIds = this.checkedIds.clone();
            this.pageSize = this.pageSizes.first();
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, false);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady() {
                let self = this;
                //
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let workServcTypeList = [];
                let workServcTypes = getEnumList("workServcType");
                if (workServcTypes != null && workServcTypes.length > 0) {
                    workServcTypes.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        workServcTypeList.push(queryItem);
                    });
                }
                query_model_ctrl.updateFields({
                    servcType: {
                        dataList: workServcTypeList
                    }
                });
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if (itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'servcTypeName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.servcType != null) {
                            return '<span class="swb-tags swb-tags-success">' + self.workServcTypeMap[row.servcType] + '</span>';
                        } else {
                            return '';
                        }
                    },
                    'violateStateName': function (row, colName, colValue, rowIndex, colConf) {
                        if (row.violated) {
                            return '<span title="' + row.violationDesc + '">' + (row.violateState == 0 ? '违约(已处理)' : '违约(未处理)') + '</span>'
                        } else {
                            return '<span>未违约</span>'
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        return '';
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination){
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            queryHandler: function (queryModel) {
                this.pageNumber = 1;
                this.queryModel = queryModel;
                this.getDataList();
            },
            getDataList() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if (!Utils.isNoB(self.filter)) {
                    filterItems = Object.assign(filterItems, self.filter);
                }
                filterItems.invalid = false;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherPageList(postData, function (result) {
                    theLoading.close();
                    if (result.type == 'info') {
                        let dataList = result.data.rows || [];
                        if(!Utils.isNoB(dataList) && dataList.length > 0) {
                            for(let i = 0; i < dataList.length; i++) {
                                let servcWorkVoucher = dataList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        //
                        let pagination = result.data.pagination;
                        self.totalCountX = pagination.totalCount;
                        if (!Utils.isNoB(pagination.totalCount) && pagination.totalCount > 10000) {
                            pagination.totalCount = 10000;
                            self.hintMsg = '总条数超过10000条，最大显示10000条，如需查看10000条以后的数据请通过条件过滤查询！';
                        }
                        self.totalCount = pagination.totalCount;
                        //
                        self.renderTable(dataList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                if (!this.checkBox) {
                    let workVoucher = this.getTableSelection();
                    if (workVoucher != null) {
                        result.type = "info";
                        result.data = workVoucher;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择工单！';
                    }
                } else {
                    let workVoucherList = this.getTableSelection() || [];
                    if (workVoucherList.length <= 0) {
                        result.type = 'warn';
                        result.message = '请选择工单！';
                    } else {
                        result.type = "info";
                        result.data = workVoucherList || [];
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherListForSelect.vue